import {colorPlugin} from '@diplodoc/color-extension';

export default colorPlugin;
